/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { VoteOnOutcomeSuggestionResponse, VoteOnOutcomeSuggestionVars } from '../openapi-types.gen.js';

export type { VoteOnOutcomeSuggestionResponse, VoteOnOutcomeSuggestionVars } from '../openapi-types.gen.js';

export const useVoteOnOutcomeSuggestion = createMutationHook<VoteOnOutcomeSuggestionVars, VoteOnOutcomeSuggestionResponse, unknown>({
  specName: 'useVoteOnOutcomeSuggestion',
  path: '/v1/outcome-suggestions/{id}/vote',
  method: 'POST',
  resolveUrl: (vars: VoteOnOutcomeSuggestionVars) => `/v1/outcome-suggestions/${vars.id}/vote`,
  buildBody: (vars: VoteOnOutcomeSuggestionVars) => ({ kind: vars.kind }),
  parseResponse: (raw: unknown): VoteOnOutcomeSuggestionResponse => raw as VoteOnOutcomeSuggestionResponse,
  optimistic: [{
    queryKey: ['markets', 'list'],
    apply: (prev: any, vars: VoteOnOutcomeSuggestionVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyOutcomeSuggestionVoteOptimistic as unknown as (prev: any, vars: VoteOnOutcomeSuggestionVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  
  
});
